<div mat-dialog-title style="margin-bottom: 0px;">
    <div style="padding-left:10px;padding-top:10px;" translate>Standards</div>
    <div style="padding-left: 10px; font-size: 14px; font-weight: normal;">{{course.Course}} - {{teacherName}}</div>
</div>

<mat-dialog-content>

    <div>
        <tyl-form-field label="Order By">
            <mat-select [(ngModel)]="selectedOrderByOption" (selectionChange)="selectedOrderByOptionChanged()">
                <mat-option [value]="1" translate>Assignment Type (A-Z)</mat-option>
                <mat-option [value]="2" translate>Assignment Type (Z-A)</mat-option>
                <mat-option [value]="3" translate>Date (Newest First)</mat-option>
                <mat-option [value]="4" translate>Date (Oldest First)</mat-option>
            </mat-select>
        </tyl-form-field>
        &nbsp;
        <tyl-form-field label="Term">
            <mat-select [(ngModel)]="termId" (selectionChange)="selectedTermChange()">
                <mat-option [value]="0" translate>All</mat-option>
                <mat-option *ngFor="let course of course.CourseTerms" [value]="course.Id">
                    {{course.LongDescription}}
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>

    <div *ngIf="gradebookObjectives.length > 0" style="padding-top: 10px; overflow-x: auto; width: 100%;">
        <table style="width: 100%;">
            <tr class="mat-header-row">
                <th style="min-width: 200px;" class="mat-header-cell" translate>Standards</th>
                <th *ngFor="let SH of gradebookStandard | orderBy: assignmentSortBy" class="mat-header-cell"
                    style="padding-right: 20px; min-width: 100px; max-width:100px;text-align: right;">
                    {{SH.Standard}}<br>
                    <span *ngIf="SH.StandardDate != '0001-01-01T00:00:00'">{{SH.StandardDate|date:'MM/dd/yy'}}</span>
                </th>
            </tr>
            <tbody>
                <tr *ngFor="let GO of gradebookObjectives | orderBy: 'SortBy'" class="mat-row"
                    style="padding: 0px; overflow: hidden; border-bottom-width: 1px;">
                    <td style="min-width: 200px;" class="mat-cell">{{GO.Standard}}</td>
                    <td *ngFor="let SH of gradebookStandard | orderBy: assignmentSortBy" class="mat-cell"
                        style="padding-right: 20px; min-width: 100px; max-width:100px; text-align: right;">
                        <span [innerHtml]="getCellValues(GO, SH)"></span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</mat-dialog-content>

<mat-dialog-actions style="position: sticky">
    <div class='flex-footer-right'>
        <tyl-button label="Close" image="Cancel.png" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>